<div class="three-dots-container" (click)="toggleDropdown($event)">
    <i class="icon-smash_dots"></i>
    <div class="three-dots-dropdown" (clickOutside)="closeDropdown()" *ngIf="dropdownDisplayed">
        <ul class="three-dots-dropdown-list">
            <ng-content>
                
            </ng-content>
        </ul>
    </div>
</div>